import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonPage,
  IonFooter,
  IonButton,
  IonLoading,
  IonImg,
  IonModal,
} from "@ionic/react";
import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  loggedInUserState,
  networkConnectionStatus,
  usernameInitialsState,
} from "../data/atoms";
import { ActionType } from "../models/Enums";
import { GetUserById } from "../services/AuthServices";
import { getFormatedMobileNumber } from "../utils/sharedFunction";
import editIcon from "../assets/images/editwhite.png";
import ErrorTopToaster from "../components/ErrorTopToaster";
import TopLeftUserName from "../components/TopLeftUserName";
import BusinessInformationModal from "../components/modals/business-information-modal";
interface Props {
  props: any;
}
const UserProfile: React.FC<Props> = ({ props }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [userToEdit, setLoggedInUser] = useRecoilState(loggedInUserState);
  // const [visible, setIsAlertVisible] = useState(false)

  let usernameInitials = useRecoilValue(usernameInitialsState);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [businessInformationModal, setShowBusinessInformationModal] =
    useState(false);

  async function GetUser() {
    //
    // setLoggedInUser(userDummy);
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setShowLoading(true);
    try {
      //;
      await GetUserById({
        localDateTime: new Date(),
        loggedInUserID: 0,
      })
        .then(function (response) {
          if (response!.data.responseCode === 1) {
            localStorage.setItem("LocationId", response!.data.user.locationId);
            localStorage.setItem(
              "WorkstationId",
              response!.data.user.workstationId
            );
            setLoggedInUser(response!.data.user);
            setShowLoading(true);
            history.replace("/edit-user-profile", {
              actionType: ActionType.EditClinician,
            });
          } else {
            // console.log(errors);
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error: any) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
    }
    setShowLoading(false);
  }

  // useEffect(() => {
  //   if (props?.actionType == ActionType.SuccessUpdateUser) {
  //     setIsAlertVisible(true);
  //     setTimeout(() => {
  //       setIsAlertVisible(false);
  //     }, 9000)
  //   }
  // }, [props?.actionType])
  //This method will check if the userToEdit object is empty or not (black screen issue Fix) //Added by Hasnat
  function isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }
  let history = useHistory();
  return (
    <IonPage placeholder={undefined}>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={"Please wait..."}
        duration={200}
      />
      {/* {
        props?.actionType == ActionType.SuccessUpdateUser && visible ? (
          <ErrorTopToaster
            errorString={"User info updated successfully"}
          />
        ) : ""
      } */}

      {/* <IonContent placeholder={undefined}>
        <IonGrid
          className="container top-spacing edit-user-page"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="main-heading top-inner-sec">
                <div
                  className="left-arrow"
                  onClick={() => {
                    history.push("/home");
                  }}
                >
                  <svg
                    className="svg-icons"
                    width="16"
                    height="26"
                    viewBox="0 0 16 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                      fill="#31344E"
                      stroke="black"
                    ></path>
                  </svg>
                </div>
                <h1>User Profile</h1>
              </div>
              <div className="edit-icon-position">
                <div className="username-wrap">
                  {userToEdit !== null &&
                    userToEdit !== undefined &&
                    !isEmpty(userToEdit) && (
                      <h2>
                        {usernameInitials.initials != ""
                          ? usernameInitials.initials
                          : localStorage.getItem("UsernameInitials")}
                      </h2>
                    )}
                </div>
                <div className="edit-icon">
                  <IonImg
                    src={editIcon}
                    alt="editIcon"
                    onClick={() => {
                      GetUser();
                    }}
                    placeholder={undefined}
                  />
                </div>
              </div>
              <div className="edit-user-name">
                {userToEdit !== null && userToEdit !== undefined && (
                  <h4>{userToEdit?.username}</h4>
                )}
              </div>
              <div className="user-profile-data">
                <ul>
                  <li>
                    <svg
                      width="26"
                      height="29"
                      viewBox="0 0 26 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2 26.75C2 22.953 6.92487 19.875 13 19.875C19.0751 19.875 24 22.953 24 26.75"
                        stroke="#31344E"
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13 15.75C16.797 15.75 19.875 12.672 19.875 8.875C19.875 5.07804 16.797 2 13 2C9.20304 2 6.125 5.07804 6.125 8.875C6.125 12.672 9.20304 15.75 13 15.75Z"
                        stroke="#31344E"
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <h4>
                        {userToEdit!.firstName} {userToEdit!.lastName}
                      </h4>
                    )}
                  </li>
                  <li>
                    <svg
                      width="27"
                      height="22"
                      viewBox="0 0 27 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23.8571 1.75H3.28571C2.57563 1.75 2 2.32563 2 3.03571V18.4643C2 19.1744 2.57563 19.75 3.28571 19.75H23.8571C24.5672 19.75 25.1429 19.1744 25.1429 18.4643V3.03571C25.1429 2.32563 24.5672 1.75 23.8571 1.75Z"
                        stroke="#31344E"
                        strokeWidth="2.57143"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2 3.03564L13.902 12.0356L25.1429 3.03564"
                        stroke="#31344E"
                        strokeWidth="2.57143"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <h4>{userToEdit!.email}</h4>
                    )}
                  </li>
                  <li className="phone-list">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3092 3.60645L9.12286 4.081L10.3092 3.60645ZM11.6564 6.97424L12.8427 6.49968L11.6564 6.97424ZM11.2468 9.55937L12.2284 10.3774L12.2284 10.3774L11.2468 9.55937ZM10.5218 10.4294L11.5034 11.2474L10.5218 10.4294ZM10.678 13.8724L9.77448 14.776H9.77448L10.678 13.8724ZM13.1276 16.322L14.0311 15.4185L13.1276 16.322ZM16.5706 16.4782L15.7526 15.4966L15.7526 15.4966L16.5706 16.4782ZM17.4406 15.7532L18.2586 16.7348L18.2586 16.7348L17.4406 15.7532ZM20.0258 15.3436L19.5512 16.53H19.5512L20.0258 15.3436ZM23.3936 16.6908L23.8681 15.5044L23.3936 16.6908ZM4.42105 3.27778H7.93647V0.722222H4.42105V3.27778ZM9.12286 4.081L10.47 7.44879L12.8427 6.49968L11.4956 3.13189L9.12286 4.081ZM10.2652 8.74136L9.5402 9.61136L11.5034 11.2474L12.2284 10.3774L10.2652 8.74136ZM9.77448 14.776L12.224 17.2255L14.0311 15.4185L11.5815 12.9689L9.77448 14.776ZM17.3886 17.4598L18.2586 16.7348L16.6226 14.7716L15.7526 15.4966L17.3886 17.4598ZM19.5512 16.53L22.919 17.8771L23.8681 15.5044L20.5003 14.1573L19.5512 16.53ZM23.7222 19.0635V22.5789H26.2778V19.0635H23.7222ZM22.5789 23.7222C11.9192 23.7222 3.27778 15.0808 3.27778 4.42105H0.722222C0.722222 16.4922 10.5078 26.2778 22.5789 26.2778V23.7222ZM23.7222 22.5789C23.7222 23.2104 23.2104 23.7222 22.5789 23.7222V26.2778C24.6218 26.2778 26.2778 24.6218 26.2778 22.5789H23.7222ZM22.919 17.8771C23.4041 18.0712 23.7222 18.541 23.7222 19.0635H26.2778C26.2778 17.4961 25.3235 16.0865 23.8681 15.5044L22.919 17.8771ZM18.2586 16.7348C18.6192 16.4343 19.1154 16.3557 19.5512 16.53L20.5003 14.1573C19.193 13.6343 17.7043 13.8702 16.6226 14.7716L18.2586 16.7348ZM12.224 17.2255C13.6259 18.6274 15.8656 18.729 17.3886 17.4598L15.7526 15.4966C15.2449 15.9196 14.4984 15.8858 14.0311 15.4185L12.224 17.2255ZM9.5402 9.61136C8.27097 11.1344 8.37256 13.3741 9.77448 14.776L11.5815 12.9689C11.1142 12.5016 11.0804 11.7551 11.5034 11.2474L9.5402 9.61136ZM10.47 7.44879C10.6443 7.88456 10.5657 8.38081 10.2652 8.74136L12.2284 10.3774C13.1298 9.29573 13.3657 7.80698 12.8427 6.49968L10.47 7.44879ZM7.93647 3.27778C8.45896 3.27778 8.92881 3.59588 9.12286 4.081L11.4956 3.13189C10.9135 1.67653 9.50394 0.722222 7.93647 0.722222V3.27778ZM4.42105 0.722222C2.37824 0.722222 0.722222 2.37825 0.722222 4.42105H3.27778C3.27778 3.78964 3.78964 3.27778 4.42105 3.27778V0.722222Z"
                        fill="#31344E"
                      />
                    </svg>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <h4>
                        {getFormatedMobileNumber(userToEdit!.mobilePhone)}
                      </h4>
                    )}
                  </li>
                </ul>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>  */}

      {/* new user page  */}

      <TopLeftUserName
        headerText={"User Profile"}
        getUser={GetUser}
      ></TopLeftUserName>

      <IonModal
        className="business-information-modal"
        backdropDismiss={false}
        isOpen={businessInformationModal}
        placeholder={undefined}
      >
        <BusinessInformationModal
          setShowModal2={setShowBusinessInformationModal}
        ></BusinessInformationModal>
      </IonModal>

      <IonContent placeholder={undefined} className="slide-in-right">
        {/* new-patient-page */}
        <IonGrid
          className="container new-edit-user-page"
          placeholder={undefined}
        >
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="heading-sec-wrap">
                <div className="heading-in-circle">
                  {userToEdit !== null &&
                    userToEdit !== undefined &&
                    !isEmpty(userToEdit) && (
                      <h1>
                        {usernameInitials.initials != ""
                          ? usernameInitials.initials
                          : localStorage.getItem("UsernameInitials")}
                      </h1>
                    )}
                </div>
                {userToEdit !== null && userToEdit !== undefined && (
                  <h4>
                    {userToEdit!.firstName} {userToEdit!.lastName}
                  </h4>
                )}
                {/* ********* patient page  ********** */}
                {/* <div className="heading-in-circle-right-sec">
                  <h4>John Doherty</h4>
                  <h5>06/20/1968, 58</h5>
                  <h6>Test Patient</h6>
                </div> */}
                {/* ********* patient page end ********** */}
              </div>
              <div className="new-user-data-list">
                <ul>
                  {/* <li>
                    <strong>Username</strong>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <span>{userToEdit?.username}</span>
                    )}
                  </li> */}
                  <li>
                    <strong>Email</strong>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <span>{userToEdit!.email}</span>
                    )}
                  </li>
                  <li>
                    <strong>Phone Number</strong>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <span>
                        {getFormatedMobileNumber(userToEdit!.mobilePhone)}
                      </span>
                    )}
                  </li>
                  <li>
                    <strong>Role</strong>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <span>{userToEdit!.clinicianRoleName}</span>
                    )}
                  </li>
                  <li>
                    <strong>Zip Code</strong>
                    {userToEdit !== null && userToEdit !== undefined && (
                      <span>{userToEdit!.zip}</span>
                    )}
                  </li>
                  {/* ********* patient page  ********** */}
                  {/* <li className="new-patient-data-list-text"><strong>Medications</strong>
                  <div className="new-patient-data-list">
                    <ul>
                      <li><span>DulX 60mg</span></li>
                      <li><span>DulX 60mg</span></li>
                      <li><span>DulX 60mg</span></li>
                      <li><span>DulX 60mg</span></li>
                    </ul>
                  </div>
                  </li> */}
                  {/* ********* patient page end  ********** */}

                  {/* <li className="phone-list">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3092 3.60645L9.12286 4.081L10.3092 3.60645ZM11.6564 6.97424L12.8427 6.49968L11.6564 6.97424ZM11.2468 9.55937L12.2284 10.3774L12.2284 10.3774L11.2468 9.55937ZM10.5218 10.4294L11.5034 11.2474L10.5218 10.4294ZM10.678 13.8724L9.77448 14.776H9.77448L10.678 13.8724ZM13.1276 16.322L14.0311 15.4185L13.1276 16.322ZM16.5706 16.4782L15.7526 15.4966L15.7526 15.4966L16.5706 16.4782ZM17.4406 15.7532L18.2586 16.7348L18.2586 16.7348L17.4406 15.7532ZM20.0258 15.3436L19.5512 16.53H19.5512L20.0258 15.3436ZM23.3936 16.6908L23.8681 15.5044L23.3936 16.6908ZM4.42105 3.27778H7.93647V0.722222H4.42105V3.27778ZM9.12286 4.081L10.47 7.44879L12.8427 6.49968L11.4956 3.13189L9.12286 4.081ZM10.2652 8.74136L9.5402 9.61136L11.5034 11.2474L12.2284 10.3774L10.2652 8.74136ZM9.77448 14.776L12.224 17.2255L14.0311 15.4185L11.5815 12.9689L9.77448 14.776ZM17.3886 17.4598L18.2586 16.7348L16.6226 14.7716L15.7526 15.4966L17.3886 17.4598ZM19.5512 16.53L22.919 17.8771L23.8681 15.5044L20.5003 14.1573L19.5512 16.53ZM23.7222 19.0635V22.5789H26.2778V19.0635H23.7222ZM22.5789 23.7222C11.9192 23.7222 3.27778 15.0808 3.27778 4.42105H0.722222C0.722222 16.4922 10.5078 26.2778 22.5789 26.2778V23.7222ZM23.7222 22.5789C23.7222 23.2104 23.2104 23.7222 22.5789 23.7222V26.2778C24.6218 26.2778 26.2778 24.6218 26.2778 22.5789H23.7222ZM22.919 17.8771C23.4041 18.0712 23.7222 18.541 23.7222 19.0635H26.2778C26.2778 17.4961 25.3235 16.0865 23.8681 15.5044L22.919 17.8771ZM18.2586 16.7348C18.6192 16.4343 19.1154 16.3557 19.5512 16.53L20.5003 14.1573C19.193 13.6343 17.7043 13.8702 16.6226 14.7716L18.2586 16.7348ZM12.224 17.2255C13.6259 18.6274 15.8656 18.729 17.3886 17.4598L15.7526 15.4966C15.2449 15.9196 14.4984 15.8858 14.0311 15.4185L12.224 17.2255ZM9.5402 9.61136C8.27097 11.1344 8.37256 13.3741 9.77448 14.776L11.5815 12.9689C11.1142 12.5016 11.0804 11.7551 11.5034 11.2474L9.5402 9.61136ZM10.47 7.44879C10.6443 7.88456 10.5657 8.38081 10.2652 8.74136L12.2284 10.3774C13.1298 9.29573 13.3657 7.80698 12.8427 6.49968L10.47 7.44879ZM7.93647 3.27778C8.45896 3.27778 8.92881 3.59588 9.12286 4.081L11.4956 3.13189C10.9135 1.67653 9.50394 0.722222 7.93647 0.722222V3.27778ZM4.42105 0.722222C2.37824 0.722222 0.722222 2.37825 0.722222 4.42105H3.27778C3.27778 3.78964 3.78964 3.27778 4.42105 3.27778V0.722222Z"
                        fill="#31344E"
                      />
                    </svg>
                    {
                      userToEdit !== null && userToEdit !== undefined && (
                        <h4>
                          {userToEdit!.clinicianRoleName}
                        </h4>
                      )

                      //<h4>(xxx) xxx-xxxx</h4>
                    }
                  </li>
                  <li className="phone-list">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3092 3.60645L9.12286 4.081L10.3092 3.60645ZM11.6564 6.97424L12.8427 6.49968L11.6564 6.97424ZM11.2468 9.55937L12.2284 10.3774L12.2284 10.3774L11.2468 9.55937ZM10.5218 10.4294L11.5034 11.2474L10.5218 10.4294ZM10.678 13.8724L9.77448 14.776H9.77448L10.678 13.8724ZM13.1276 16.322L14.0311 15.4185L13.1276 16.322ZM16.5706 16.4782L15.7526 15.4966L15.7526 15.4966L16.5706 16.4782ZM17.4406 15.7532L18.2586 16.7348L18.2586 16.7348L17.4406 15.7532ZM20.0258 15.3436L19.5512 16.53H19.5512L20.0258 15.3436ZM23.3936 16.6908L23.8681 15.5044L23.3936 16.6908ZM4.42105 3.27778H7.93647V0.722222H4.42105V3.27778ZM9.12286 4.081L10.47 7.44879L12.8427 6.49968L11.4956 3.13189L9.12286 4.081ZM10.2652 8.74136L9.5402 9.61136L11.5034 11.2474L12.2284 10.3774L10.2652 8.74136ZM9.77448 14.776L12.224 17.2255L14.0311 15.4185L11.5815 12.9689L9.77448 14.776ZM17.3886 17.4598L18.2586 16.7348L16.6226 14.7716L15.7526 15.4966L17.3886 17.4598ZM19.5512 16.53L22.919 17.8771L23.8681 15.5044L20.5003 14.1573L19.5512 16.53ZM23.7222 19.0635V22.5789H26.2778V19.0635H23.7222ZM22.5789 23.7222C11.9192 23.7222 3.27778 15.0808 3.27778 4.42105H0.722222C0.722222 16.4922 10.5078 26.2778 22.5789 26.2778V23.7222ZM23.7222 22.5789C23.7222 23.2104 23.2104 23.7222 22.5789 23.7222V26.2778C24.6218 26.2778 26.2778 24.6218 26.2778 22.5789H23.7222ZM22.919 17.8771C23.4041 18.0712 23.7222 18.541 23.7222 19.0635H26.2778C26.2778 17.4961 25.3235 16.0865 23.8681 15.5044L22.919 17.8771ZM18.2586 16.7348C18.6192 16.4343 19.1154 16.3557 19.5512 16.53L20.5003 14.1573C19.193 13.6343 17.7043 13.8702 16.6226 14.7716L18.2586 16.7348ZM12.224 17.2255C13.6259 18.6274 15.8656 18.729 17.3886 17.4598L15.7526 15.4966C15.2449 15.9196 14.4984 15.8858 14.0311 15.4185L12.224 17.2255ZM9.5402 9.61136C8.27097 11.1344 8.37256 13.3741 9.77448 14.776L11.5815 12.9689C11.1142 12.5016 11.0804 11.7551 11.5034 11.2474L9.5402 9.61136ZM10.47 7.44879C10.6443 7.88456 10.5657 8.38081 10.2652 8.74136L12.2284 10.3774C13.1298 9.29573 13.3657 7.80698 12.8427 6.49968L10.47 7.44879ZM7.93647 3.27778C8.45896 3.27778 8.92881 3.59588 9.12286 4.081L11.4956 3.13189C10.9135 1.67653 9.50394 0.722222 7.93647 0.722222V3.27778ZM4.42105 0.722222C2.37824 0.722222 0.722222 2.37825 0.722222 4.42105H3.27778C3.27778 3.78964 3.78964 3.27778 4.42105 3.27778V0.722222Z"
                        fill="#31344E"
                      />
                    </svg>
                    {
                      userToEdit !== null && userToEdit !== undefined && (
                        <h4>
                          {userToEdit!.zip}
                        </h4>
                      )

                      //<h4>(xxx) xxx-xxxx</h4>
                    }
                  </li> */}
                </ul>
                <div
                  className="display-flex-center business-view-info-text"
                  onClick={() => {
                    setShowBusinessInformationModal(true);
                  }}
                >
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.75 4V2C9.75 0.9 8.8725 0 7.8 0H1.95C0.8775 0 0 0.9 0 2V16C0 17.1 0.8775 18 1.95 18H17.55C18.6225 18 19.5 17.1 19.5 16V6C19.5 4.9 18.6225 4 17.55 4H9.75ZM3.9 16H1.95V14H3.9V16ZM3.9 12H1.95V10H3.9V12ZM3.9 8H1.95V6H3.9V8ZM3.9 4H1.95V2H3.9V4ZM7.8 16H5.85V14H7.8V16ZM7.8 12H5.85V10H7.8V12ZM7.8 8H5.85V6H7.8V8ZM7.8 4H5.85V2H7.8V4ZM16.575 16H9.75V14H11.7V12H9.75V10H11.7V8H9.75V6H16.575C17.1112 6 17.55 6.45 17.55 7V15C17.55 15.55 17.1112 16 16.575 16ZM15.6 8H13.65V10H15.6V8ZM15.6 12H13.65V14H15.6V12Z"
                      fill="#005A75"
                    />
                  </svg>
                  <p>View Business Information</p>
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>

      {/* Hide the Logout button from User Profile Page */}
      {/* <IonFooter
        className="edit-user-page-footer ion-no-border"
        placeholder={undefined}
      >
        <div className="btn-wrap-sec single-btn-wrap">
          <IonButton
            onClick={() => {
              history.replace("/confirmation", {
                actionType: ActionType.Logout,
              });
            }}
            className="generic-btn"
            type="submit"
            placeholder={undefined}
          >
            Logout
          </IonButton>
        </div>
      </IonFooter> */}
    </IonPage>
  );
};
export default UserProfile;
